import { FC, ReactNode } from 'react';
import useWindowDimensions from '~/shared/hooks/useWindowDimentions';
import {
  cvaPaymentBox,
  cvaPaymentBoxInner,
} from '~/widgets/Payment/ui/PaymentBox/PaymentBoxStyles';

interface Props {
  children: ReactNode;
  variant?: 'all' | 'nonR';
}

export const PaymentBox: FC<Props> = ({ children, variant }) => {
  const { height } = useWindowDimensions();

  return (
    <div className={cvaPaymentBox()} style={{ top: height - 92 }}>
      <div
        className={cvaPaymentBoxInner({ padding: variant ? variant : 'all' })}>
        {children}
      </div>
    </div>
  );
};
